import * as React from "react";
import { forwardRef } from "react";
const SvgPodcastPause = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 22, viewBox: "0 0 16 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { width: 5.33333, height: 21.3333, transform: "matrix(1 0 0 -1 0 21.3333)" }), /* @__PURE__ */ React.createElement("rect", { width: 5.33333, height: 21.3333, transform: "matrix(1 0 0 -1 10.6667 21.3333)" }));
const ForwardRef = forwardRef(SvgPodcastPause);
export { ForwardRef as ReactComponent };
